<template>
    <section>
        <h2 class="mb-3 text-content-lg font-semibold">Default</h2>
        <DsZoomableCanvas class="min-h-96">
            <p class="w-60 bg-ds-primary-50 p-4 text-center shadow-md">Click anywhere on the canvas to drag the card</p>
        </DsZoomableCanvas>
    </section>
    <section class="mt-8">
        <h2 class="mb-3 text-content-lg font-semibold">Initial position</h2>
        <p class="mb-3">Custom initial position</p>
        <DsZoomableCanvas
            class="min-h-96"
            :initialPosition="{ x: -300, y: 100 }"
        >
            <p class="w-60 bg-ds-primary-50 p-4 text-center shadow-md">This card has an initial position of (x: -300, y: 100)</p>
        </DsZoomableCanvas>
    </section>
</template>

<script setup lang="ts">
import DsZoomableCanvas from '@/components/design-system/canvas/DsZoomableCanvas.vue';
</script>
